
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { putExtend } from "@/api/product-number";
@Component({
  name: "LookRemark",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: () => [] }) private remarkInfo: [];
  @Prop({ default: '' }) private productNumberId: "";
  private submitSave = false;
  private close() {
    this.$emit("update:show", false);
  }

  private addRemark() {
    this.$emit("addRemark")
  }

  private removeRemark(index) {
    this.$emit("removeRemark",index)
  }

  private async putExtendInfo() {
    this.submitSave = true
    let data = {
      req: this.remarkInfo
    }
    await putExtend(this.productNumberId,data).then(res => {
      this.submitSave = false
        this.$notify({
        title: "成功",
        message: "提交成功",
        type: "success",
        duration: 2000,
      });
      this.close()
      this.$emit("putExtendInfo")
    }).catch(err=>{
      this.submitSave = false
      console.log(err)
    })
  }
}
